import { Fragment } from "react";
import { useLanguage } from "../../../../widgets/LangContext";
import {
  MoneyFormat,
  NumberToNepaliNum,
} from "../../../../widgets/NumberFormat";
import { useSelector } from "react-redux";
import AppURL from "../../../../widgets/AppURL";

const PrintPartTimeSalaryView = ({ PayrollList, onMonth }) => {
  const { language } = useLanguage();
  const { menu_list } = useSelector((state) => state?.software);
  const report_footer_items = menu_list?.account_footer;
  const Org_Details = menu_list?.structure;
  const DateNow = menu_list?.date_ne;
  let totals = {
    salary_with_s_kosh: 0,
    part_tot_salary: 0,
    total: 0,
  };
  PayrollList?.data?.forEach((emp) => {
    totals.salary_with_s_kosh +=
      (emp?.basic_tot_salary * 16) / 100 +
        (emp?.allowance_amt + emp?.basic_tot_salary) || 0;
    totals.part_tot_salary +=
      emp?.post_allowance +
      emp?.extra_period +
      emp?.irre_period +
      emp?.sem_period +
      emp?.holiday_thap -
      emp?.holiday_katti -
      ((emp?.post_allowance +
        emp?.extra_period +
        emp?.irre_period +
        emp?.sem_period +
        emp?.holiday_thap -
        emp?.holiday_katti) *
        1) /
        100;
    totals.total +=
      emp?.post_allowance +
      emp?.extra_period +
      emp?.irre_period +
      emp?.sem_period +
      emp?.holiday_thap -
      emp?.holiday_katti -
      ((emp?.post_allowance +
        emp?.extra_period +
        emp?.irre_period +
        emp?.sem_period +
        emp?.holiday_thap -
        emp?.holiday_katti) *
        1) /
        100 +
      Number(emp?.allowance_amt + emp?.basic_tot_salary) -
      (emp?.basic_tot_salary * 15) / 100 -
      emp?.hit_kosh;
  });

  return (
    <Fragment>
      <style>
        {`@media print {
                    @page {
                        size: A4 landscape;
                        margin: 0.2in;
                        border: 1px solid oklch(0.145 0 0); 
                        page-break-before: always;
                    }
                }
            `}
      </style>
      <div className="bg-white h-[100vh]">
        <div className="relative border-x border-t border-slate300 p-0.5">
          <table className="w-full text-sm text-left rtl:text-right text-black">
            <tbody>
              <tr>
                <td
                  className={`w-[25%] text-[12px] text-black whitespace-nowrap ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {language ? "Reg. No.: " : "दर्ता नं.:"}:{" "}
                  {language
                    ? Org_Details?.org_reg
                    : NumberToNepaliNum(Org_Details?.org_reg || "")}
                </td>
                <td className="w-[25%]"></td>
                <td className="w-[25%]"></td>
                <td
                  align="right"
                  className={`w-[25%] text-[12px] text-black whitespace-nowrap ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {language ? "Phone: " : "फोन नम्बर:"}{" "}
                  {language
                    ? Org_Details?.org_phone
                    : NumberToNepaliNum(Org_Details?.org_phone || 0)}
                </td>
              </tr>
              <tr>
                <td
                  rowSpan={4}
                  className="w-[25%] font-medium text-black whitespace-nowrap"
                >
                  <img
                    width={60}
                    height={60}
                    src={AppURL.BaseURL + Org_Details?.logo}
                    alt=""
                  />
                </td>
                <td
                  align="center"
                  colSpan={2}
                  className={`w-[25%] text-black font-bold text-[18px] ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {language ? Org_Details?.org_name : Org_Details?.org_name_nep}
                </td>
                <td className="w-[25%]"></td>
              </tr>
              <tr>
                <td
                  align="center"
                  colSpan={2}
                  className={`w-[25%] text-black font-normal text-[12px] ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {language ? Org_Details?.org_add : Org_Details?.org_add_nep}
                </td>
                <td
                  align="right"
                  className={`w-[25%] text-[11px] text-black font-normal ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {language ? "Date: " : "मिति: "}{" "}
                  {language ? DateNow : NumberToNepaliNum(DateNow)}
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  colSpan={2}
                  className={`w-[25%] underline underline-offset-2 text-black font-bold text-[15px] ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                >
                  {onMonth} {"Full/Part Time Salary Report"}
                </td>
                <td className="w-[25%]"></td>
              </tr>
              <tr>
                <td
                  align="center"
                  colSpan={2}
                  className={`w-[25%] text-black font-light text-[11px] ${
                    language ? "font-public-sans" : "font-sangrila"
                  }`}
                ></td>
                <td align="right" className="w-[25%] text-[11px]"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-white dark:bg-slate800 shodow rounded-md p-2">
          <div className="relative w-full overflow-x-auto">
            <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-slate700 dark:text-slate400">
              <thead className="text-[11px] top-0 sticky z-10 font-public-sans text-slate800 capitalize border-b dark:bg-slate700 bg-slate200 dark:text-slate100 dark:border-slate700">
                <tr>
                  <th
                    scope="col"
                    className="px-2 py-0.5 border border-slate300 dark:border-gray-700 w-10"
                  >
                    S.N.
                  </th>
                  <th
                    scope="col"
                    className="px-2 bg-slate200 sticky left-0 py-0.5 border border-slate300 dark:border-gray-700"
                  >
                    Emp Name
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-0.5 border border-slate300 dark:border-gray-700"
                  >
                    Designation
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-0.5 border border-slate300 dark:border-gray-700"
                  >
                    Part Tot. Salary
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-0.5 border border-slate300 dark:border-gray-700"
                  >
                    Receivable Amount
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-0.5 border border-slate300 dark:border-gray-700"
                  >
                    Total Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(PayrollList?.data) &&
                PayrollList?.data?.length > 0 ? (
                  PayrollList?.data?.map((emp, index) => (
                    <tr
                      key={index}
                      className="bg-white hover:bg-slate100 hover:cursor-pointer text-[11px] font-public-sans dark:bg-slate800 text-slate800 dark:hover:bg-slate600"
                    >
                      <td
                        align="center"
                        className="px-2 py-0.5 border border-slate300 dark:border-slate700"
                      >
                        {index + 1}.
                      </td>
                      <td className="px-2 py-0.5 capitalize bg-white border border-slate300 dark:border-slate700 italic">
                        {`${emp?.first_name ? emp?.first_name : ""} ${
                          emp?.middle_name ? emp?.middle_name : ""
                        } ${emp?.last_name ? emp?.last_name : ""}`}
                      </td>
                      <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                        {emp?.designation_name}
                      </td>
                      <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                        {Number(
                          (emp?.basic_tot_salary * 16) / 100 +
                            (emp?.allowance_amt + emp?.basic_tot_salary)
                        ).toFixed(2)}
                      </td>
                      <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                        {Number(
                          emp?.post_allowance +
                            emp?.extra_period +
                            emp?.irre_period +
                            emp?.sem_period +
                            emp?.holiday_thap -
                            emp?.holiday_katti -
                            ((emp?.post_allowance +
                              emp?.extra_period +
                              emp?.irre_period +
                              emp?.sem_period +
                              emp?.holiday_thap -
                              emp?.holiday_katti) *
                              1) /
                              100
                        ).toFixed(2)}
                      </td>
                      <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                        {Number(
                          parseFloat(
                            (emp?.basic_tot_salary * 16) / 100 +
                              (emp?.allowance_amt + emp?.basic_tot_salary)
                          ) +
                            parseFloat(
                              emp?.post_allowance +
                                emp?.extra_period +
                                emp?.irre_period +
                                emp?.sem_period +
                                emp?.holiday_thap -
                                emp?.holiday_katti -
                                ((emp?.post_allowance +
                                  emp?.extra_period +
                                  emp?.irre_period +
                                  emp?.sem_period +
                                  emp?.holiday_thap -
                                  emp?.holiday_katti) *
                                  1) /
                                  100
                            )
                        ).toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="bg-white text-[12px] font-public-sans dark:bg-slate800 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <td
                      align="center"
                      colSpan={16}
                      className="px-2 py-1 border dark:border-gray-700"
                    >
                      <span>No Payroll Found</span>
                    </td>
                  </tr>
                )}
                <tr className="bg-gray-100 text-[10px] dark:bg-gray-800 font-bold font-public-sans">
                  <td
                    colSpan={3}
                    className="px-2 py-0.5 border border-slate300"
                  >
                    Total
                  </td>
                  <td className="px-2 py-0.5 border border-slate300">
                    {MoneyFormat(totals.salary_with_s_kosh)}
                  </td>
                  <td className="px-2 py-0.5 border border-slate300">
                    {MoneyFormat(totals.part_tot_salary)}
                  </td>
                  <td className="px-2 py-0.5 border border-slate300">
                    {MoneyFormat(
                      parseFloat(totals.salary_with_s_kosh) +
                        parseFloat(totals.part_tot_salary)
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="absolute bottom-0 w-full pt-4 px-2">
          <div className="flex justify-between items-center">
            <div className="flex-grow"></div>
            <div
              className={`flex justify-between w-full items-center space-x-8 ${
                language ? "font-public-sans" : "font-sangrila"
              }`}
            >
              {report_footer_items?.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center"
                >
                  <h2 className="text-[14px] font-bold">
                    ............................
                  </h2>
                  <h2 className="font-bold text-[12px] mt-1">
                    {language ? item?.name : item?.name_nepali}
                  </h2>
                  <h2 className="font-normal text-[10px] mt-0.5">
                    {language ? item?.designation : item?.designation_nepali}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PrintPartTimeSalaryView;
